<template>
    <a-input
      class="search-input"
      :placeholder="placeholder"
      v-model:value="searchString"
      @keyup.enter="runSearching()"
    />
</template>

<script setup>
import {onMounted, ref, watch} from "vue";
import {useRoute, useRouter} from "vue-router";

const route = useRoute();
const router = useRouter();

let searchString = ref("");
let searchArea = ref("");

defineProps({
  placeholder: {
    type: String,
    default: "Поиск...",
  },
});

const runSearching = () => {
  if (!searchString.value) return;
  router.push({
    path: '/portal/search',
    query: {
      ...route.query,
      q: searchString.value,
      area: searchArea.value,
      page: 1,
      'per-page': 10
    }
  });
}

const getArea = (routeName) => {
  if (routeName.startsWith('portal-department')) return 'department';
  if (routeName.startsWith('portal-person')) return 'person';
  if (routeName.startsWith('portal-publication')) return 'publication';
  if (routeName.startsWith('portal-intellectual')) return 'intellectual';
  return '';
}

watch(() => route.query.area, (newArea) => {
  if (!newArea) return;
  searchArea.value = newArea;
});

watch(() => route.name, (newRouteName) => {
  if (!newRouteName) return;
  searchArea.value = getArea(newRouteName);
});

onMounted(() => {
  let queryArea = route.query.area ?? null;
  searchArea.value = queryArea ? queryArea : getArea(route.name);
  searchString.value = route.query.q ?? '';
});
</script>

<style lang="scss" scoped>
.search-input {
  width: 100%;
  max-width: 555px;
  background: url("assets/search.svg") no-repeat 14px center #f2f4f8;
  padding-left: 55px;

  &.dark {
    background-color: #383D4F;
    border-color: #383D4F;
    color: #BABBC2;

    &::placeholder {
      color: #BABBC2;
    }
  }
}
</style>
